import { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap/esm";
import { Link, useLocation } from "react-router-dom";
import { MenuItem, MenuProps } from "./props/CommonPropTypes";
import logoSource from "../../assets/stm-mark.jpg";

export const ApplicationMainMenu: React.FC<MenuProps> = ({ ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const { pathname } = useLocation();

  const isCurrent = (menuItem: MenuItem) => {
    const paths = [menuItem.path].concat(menuItem.matchPaths || []);
    return paths.some(
      (path) => pathname === path || pathname.startsWith(`${path}/`)
    );
  };

  return (
    <div id="application-main-menu" className="application-main-menu">
      <Navbar
        className="application-main-menu-container-navbar"
        expand="md"
        expanded={expanded}
        onToggle={(nextExpanded: boolean) => setExpanded(nextExpanded)}
      >
        <Container className="application-main-menu-container">
          <Navbar.Brand
            className="application-main-menu-brand"
            as={Link}
            to="/home"
            onClick={() => setExpanded(false)}
          >
            <img
              className="App-logo"
              src={logoSource}
              alt="Steamtown Media Limited"
            />
            <span className="stm-main-menu-header">Steamtown Media</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="application-main-menu-nav" />
          <Navbar.Collapse
            id="application-main-menu-nav"
            className="justify-content-end"
          >
            <Nav>
              {props.menuItems.map((menuItem) => (
                <Nav.Link
                  key={menuItem.id}
                  id={menuItem.id}
                  className={menuItem.className}
                  as={Link}
                  to={menuItem.path}
                  active={isCurrent(menuItem)}
                  onClick={() => {
                    setExpanded(false);
                    if (menuItem.onClick) {
                      menuItem.onClick();
                    }
                  }}
                >
                  {menuItem.title}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};
